import * as React from 'react'
import {Component} from 'react'
import Select from 'antd/lib/select'
import 'antd/lib/select/style'
import Input from 'antd/lib/input'
import 'antd/lib/input/style'
import {MessageDTORegionEnum} from '../../../../api/sms/models'

export interface CountryPhoneMask {
    code: string // "+680"
    flag: string // "https://www.countryflags.io/PW/flat/24.png"
    iso: MessageDTORegionEnum // "PW"
    mask: string | string[] // "###-####"
    name: string // "Palau"
}

const countriesPhoneMasks: CountryPhoneMask[] = [
    {
        code: '+7',
        flag: 'https://www.countryflags.io/RU/flat/24.png',
        iso: MessageDTORegionEnum.RU,
        mask: '(###)###-##-##',
        name: 'Russia',
    },
    {
        code: '+375',
        flag: 'https://www.countryflags.io/BY/flat/24.png',
        iso: MessageDTORegionEnum.BY,
        mask: '(##)###-##-##',
        name: 'Belarus',
    },
    {
        code: '+77',
        flag: 'https://www.countryflags.io/KZ/flat/24.png',
        iso: MessageDTORegionEnum.KZ,
        mask: ['(6##)###-##-##', '(7##)###-##-##'],
        name: 'Kazakhstan',
    },
    {
        code: '+380',
        flag: 'https://www.countryflags.io/UA/flat/24.png',
        iso: MessageDTORegionEnum.UA,
        mask: '(##)###-##-##',
        name: 'Ukraine',
    },
]

export const russia = countriesPhoneMasks[0]
const russiaIndex = countriesPhoneMasks.findIndex(country => country.name === russia.name)

export interface InternationalPhoneValueInterface {
    country: CountryPhoneMask
    phone: string
}

interface InternationalPhoneProps {
    countriesPhoneMasks?: CountryPhoneMask[]
    value?: InternationalPhoneValueInterface
    disabled?: boolean
    onChange?: (e: any) => () => void
}

interface InternationalPhoneState {
    country: CountryPhoneMask
    phone: string
}

class InternationalPhone extends Component<InternationalPhoneProps, InternationalPhoneState> {
    constructor(props: InternationalPhoneProps) {
        super(props)

        this.state = {
            country: props?.value?.country || russia,
            phone: props?.value?.phone || '',
        }
    }

    static defaultProps = {
        disabled: false,
        countriesPhoneMasks: countriesPhoneMasks,
        onChange: () => {},
    }

    changeValue = e => {
        if (e.type === 'change') {
            const {value} = e.target
            this.setState({phone: value}, () => {
                this.props.onChange({...this.state, phone: value})
            })
        }
    }

    changeCountry = value => {
        const country = this.props.countriesPhoneMasks.find(country => country.name === value)
        this.setState({country, phone: ''}, () => this.props.onChange({country, phone: ''}))
    }

    static getDerivedStateFromProps(nextProps) {
        if ('value' in nextProps) {
            return {
                ...(nextProps.value || {}),
            }
        }
        return null
    }

    render() {
        const {country, phone} = this.state
        const {disabled, countriesPhoneMasks} = this.props

        return (
            <Input.Group compact>
                <Select
                    style={{width: '30%'}}
                    value={country.name}
                    onChange={this.changeCountry}
                    showSearch
                    optionFilterProp={'children'}
                >
                    {countriesPhoneMasks.map((country, i) => (
                        <Select.Option value={country.name} key={country.name}>
                            {/*<img src={country.flag} alt='flag' /> */}
                            {country.name}
                        </Select.Option>
                    ))}
                </Select>
                <Input
                    addonBefore={country.code}
                    value={phone}
                    style={{width: '70%'}}
                    disabled={disabled}
                    onChange={this.changeValue}
                />
            </Input.Group>
        )
    }
}

export default InternationalPhone
